import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-2.188-9.688H7.626V14.5h2.188v-2.188Zm3.282 0V14.5h-2.188v-2.188h2.188Zm3.281 0h-2.188V14.5h2.188v-2.188Z" }));
export default createSvgIcon(iconPath, "Others");
//# sourceMappingURL=StatusOthersIcon.js.map